import Uppy from '@uppy/core';
import ProgressBar from '@uppy/progress-bar';
import XHRUpload from '@uppy/xhr-upload';
import { getUniqueId } from 'api/canguard/getUniqueVVFileID';
import { format } from 'date-fns';

export const getAdminUploadUppy = (patrol: ScheduleAssignment) => {
	if (!patrol.comment_list_id)
		throw new Error(
			'Cannot create uppy instance for a patrol which has not started yet.',
		);
	if (!patrol.work_date)
		throw new Error(
			'Error creating uppy instance: patrol.work_date is undefined.',
		);
	const uppy = new Uppy({
		id: patrol.comment_list_id.toString(),
		meta: {
			patrol: patrol,
			customerName: patrol.cust_name,
			addressName: patrol.address,
			patrolId: patrol.comment_list_id,
			startTime: format(patrol.start_time, 'P p'), // 'P p' gives '7/11/2024 9:30:00 PM'. This is what the backend expects.
			patrolDate: format(patrol.work_date, 'P'), // 'P' gives '7/11/2024'. This is what the backend expects.
		},
		allowMultipleUploadBatches: true,
		autoProceed: true,
		restrictions: {
			allowedFileTypes: ['video/*'],
		},
	})
		.use(XHRUpload, {
			endpoint: '/api2.0/candds/upload',
			formData: true,
			fieldName: 'Files',
			timeout: 0,
		})
		.on('upload-success', (file: any, response) => {
			console.log('file uploaded:', file.id);
			console.log('response >> ', response);
		})
		.on('upload-error', (file: any, error, response) => {
			console.log('error with file:', file.id);
			console.log('error message:', error);
			console.log('response >> ', response);
		});

	return uppy;
};

export const getPatrolUppyInstance = (comment_list_id: number) => {
	const uppy = new Uppy({
		restrictions: {
			maxNumberOfFiles: 5,
			allowedFileTypes: [
				'video/*', // All video file types
				'image/*', // All image file types
				'.pdf',
				'.doc',
				'.docx',
				'.txt',
			],
		},
		locale: {
			strings: {
				myDevice: `Camera or Files`,
			},
		},
	})
		.use(XHRUpload, {
			fieldName: 'file',
			formData: true,
			endpoint: '',
		})
		.on('file-added', (file) => {
			const { id } = file;

			if (file.name.startsWith('image.')) {
				const currentTimestamp = Date.now();
				const fileExtension = file.name.split('.').pop();
				const newName = `image_${currentTimestamp}.${fileExtension}`;
				file.meta.name = newName;
				uppy.setFileState(id, {
					name: newName,
				});
			}

			getUniqueId().then((muc) => {
				let url = `/Project/Webservice/FileUpload.aspx/UploadFile?muc=${muc.d}&cml=${comment_list_id}&wbs=undefined&is=n`;
				if (process.env.NODE_ENV === 'production') {
					url = '/Portal' + url;
				}
				uppy.setFileState(id, {
					xhrUpload: {
						fieldName: 'filedata',
						formData: true,
						endpoint: url,
					},
				});
			});
		});
	// onComplete is added in CheckpointAttachmentResponse.tsx. We add a onFileUploadSuccess function to handle the file upload success event.
	return uppy;
};

export const getCheckpointUppyInstance = (checkpointID: number) => {
	const uppy = new Uppy({
		restrictions: {
			maxNumberOfFiles: 5,
			allowedFileTypes: [
				'video/*', // All video file types
				'image/*', // All image file types
				'.pdf',
				'.doc',
				'.docx',
				'.txt',
			],
		},
		locale: {
			strings: {
				myDevice: `Camera or Files`,
			},
		},
	})
		.use(XHRUpload, {
			fieldName: 'file',
			formData: true,
			endpoint: '',
		})
		.on('file-added', (file) => {
			const { id } = file;

			getUniqueId().then((muc) => {
				let url = `/Project/Webservice/FileUpload.aspx/UploadFile?muc=${muc.d}&cml=undefined&wbs=undefined&is=n&checkpointID=${checkpointID}`;
				if (process.env.NODE_ENV === 'production') {
					url = '/Portal' + url;
				}
				uppy.setFileState(id, {
					xhrUpload: {
						fieldName: 'filedata',
						formData: true,
						endpoint: url,
					},
				});
			});
		});
	// onComplete is added in CheckpointAttachmentResponse.tsx. We add a onFileUploadSuccess function to handle the file upload success event.
	return uppy;
};
